import lazy from 'utils/lazy';

export const PaymentResult = lazy(() => import('./PaymentResult'));
